import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlServicesPatientAdmin } from 'src/app/core/constants/patients-admin.constants';
import { RestService } from 'src/app/core/services/communication-rest/communication-rest.service';
import { AllergensDto, AllergyDto, StatusAllergyDto, GravityAllergiesDto, AllergiesTypesDto } from "src/app/core/models/patient/module-allergy.dto";
import { WorkplaceStorageService } from 'src/app/core/services/local/workplaces-storage.service';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AllergiesPatientService {

  urls = urlServicesPatientAdmin.allergies;

  private activatedRoute: ActivatedRoute | null = null;

  constructor(protected restService: RestService) {}

  setActivatedRoute(route: ActivatedRoute): void {
    this.activatedRoute = route;
  }


  getStatusByBranch(branchId: number): Observable<StatusAllergyDto[]> {
    return this.restService.get(`${this.urls.statusAllergies}/by-branch?branchOfficeId=${branchId}`, true);
  }

  getGravityByBranch(branchId: number): Observable<GravityAllergiesDto[]> {
    return this.restService.get(`${this.urls.gravityAllergies}/by-branch?branchOfficeId=${branchId}`, true);
  }

  getAllergiesTypesByBranch(branchId: number): Observable<AllergiesTypesDto[]> {
    return this.restService.get(`${this.urls.allergiesTypes}/by-branch?branchOfficeId=${branchId}`, true);
  }

  getAllergensByBranch(branchId: number): Observable<AllergensDto[]> {
    return this.restService.get(`${this.urls.allergens}/by-branch?branchOfficeId=${branchId}`, true);
  }

  getAllergiesByPatientId(skipLoading?: boolean): Observable<AllergyDto[]> {
    const patientId = WorkplaceStorageService.getPatientIdMenu();
    if (!patientId) {
      throw new Error('Patient ID not found');
    }
    return this.restService.get(`${this.urls.allergiesFilterPatient}/${patientId}`, skipLoading);
  }

  addAllergy(allergyData: AllergyDto): Observable<AllergyDto> {
    return this.restService.post(`${this.urls.allergies}`, allergyData);
  }

  updateAllergy(id: number, allergyData: AllergyDto): Observable<AllergyDto> {
    return this.restService.put(`${this.urls.allergies}/${id}`, allergyData);
  }

  createAllergen(allergensData: AllergensDto): Observable<AllergensDto> {
    return this.restService.post(`${this.urls.allergens}`, allergensData);
  }
}
